export default {
  blue: '#2196f3',
  blueDark: '#0064d2',
  blueMedium: '#96dcfd',
  blueLight: '#dcf8fe',
  blueSuperLight: '#f0fdff',

  green: '#8bc34a',
  greenDark: '#509600',
  greenMedium: '#c8e696',
  greenLight: '#e6fad7',
  greenSuperLight: '#f7fcf5',

  grey: '#4c525b',
  greyDark: '#2a2e32',
  greyMedium: '#a1aab0',
  greyLight: '#cfd4d8',
  greySuperLight: '#eef0f2',
  greyCharcoal: '#404042',
  greyAsh: '#a3a3a3',
  greySnow: '#e1e1e1',
  greyNobel: '#a2a2a2',
  greyBlue: '#e1ecf1',

  greyD8: '#d8d8d8', // not in the design system
  grey65: '#586065', // not in the design system
  greyNavTitle: '#101825',

  greyAccountBackground: '#f6f8fa',
  greySpinner: '#999999',

  navy: '#0d47a1',
  navyDark: '#002864',
  navyMedium: '#87b2ea',
  navyLight: '#d2e6fa',
  navySuperLight: '#effaff',

  pink: '#e5258c',
  pinkDark: '#b40064',
  pinkMedium: '#fabeeb',
  pinkLight: '#fde6fc',
  pinkSuperLight: '#fff6ff',
  pinkClassicRose: '#fad1ee',

  purple: '#823cd7',
  purpleDark: '#5a1eb4',
  purpleMedium: '#c3b4ff',
  purpleLight: '#e6e6ff',
  purpleSuperLight: '#f5f5ff',

  purpleA7: '#a79dbf', // not in the design system

  red: '#ff2751',
  redDark: '#cb144b',
  redMedium: '#ffa0b6',
  redLight: '#ffe1e9',
  redSuperLight: '#fff3f6',

  redDot: '#FF5858',
  redE2: '#e28080', // not in the design system
  paidyBlum: '#CA4444',

  black: '#000',
  // @TODO: Fix design system black => deprecatedBlack, blackMedium => black
  blackMedium: '#101825',
  blackPaidy: '#1c1c1c',

  white: '#fff',
  whiteOff: '#f0f0f0',

  yellow: '#ffcd00',
  yellowDark: '#e58b00',
  yellowMedium: '#ffe36e',
  yellowLight: '#fff5b3',
  yellowSuperLight: '#fffbea',

  teal: '#607d8b',

  amour: '#ede9ea',

  cherry: '#faf8f8',
  paidyBlue: '#75adc5',

  blueA6: '#a6d2e4', // not in the design system

  // Merchant default colors
  beige: '#e6e1dc',
  beigeLight: '#f4f4f4', // beige Hue - 2
  beigeSupperLight: '#fcf8f4', // beige Hue - 1

  cherryLight: '#f6f1f1', // Cherry Hue - 3
  alertRed: '#db263e',
};
